import { render, staticRenderFns } from "./Races.vue?vue&type=template&id=78c994be&scoped=true&"
import script from "./Races.vue?vue&type=script&lang=js&"
export * from "./Races.vue?vue&type=script&lang=js&"
import style0 from "./Races.vue?vue&type=style&index=0&id=78c994be&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c994be",
  null
  
)

export default component.exports